import { jsxs as a, Fragment as e, jsx as o } from "react/jsx-runtime";
import { c as i } from "../../index-C7ezJk5b.js";
import { I as l } from "../../help-DxBNz34u.js";
import { b as p } from "../../base-nYmjnkiN.js";
import "react";
import { cssX as t, cssTI as n } from "../../core/utils/css.js";
import "react-dom";
import m from "../../components/Tooltip/Tooltip.js";
import '../../assets/Wrapper.css';/* empty css                     */
import "react-router-dom";
const x = () => {
  const {
    userInfo: {
      helpCenterUrl: r
    }
  } = p();
  return /* @__PURE__ */ a(e, { children: [
    /* @__PURE__ */ o(
      "a",
      {
        target: "_blank",
        href: r,
        className: i(t("PlatformNavigation__button"), t("Icon")),
        "data-tooltip-id": t("platform-navigation-help-tooltip"),
        "data-testid": n("button", "PlatformNavigationHelp"),
        children: /* @__PURE__ */ o(l, {})
      }
    ),
    /* @__PURE__ */ o(
      m,
      {
        id: t("platform-navigation-help-tooltip"),
        place: "left",
        children: "Help Center"
      }
    )
  ] });
};
export {
  x as default
};
